// @flow

import { localize } from '@ta/common.i18n';

/** Renders a node to display within a toast, prompting users that they do not have permission */

/** You don't have permission to take this action.  */
const NoPermissionToast = () => localize('social_no_permission');

export default NoPermissionToast;
